
import { CompleteCalendar } from '@react-admin/ra-calendar';
// import { Calendar } from "@react-admin/ra-calendar";

import {
    SimpleForm,
    TextInput,
} from 'react-admin';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import timeGridPlugin from '@fullcalendar/timegrid';

import faLocale from "@fullcalendar/core/locales/fa";
import { IdateTimeInput } from '../../data/IdateTimeInput';
import CreateView from '../../components/CreateView';
import EditView from '../../components/EditView';

export const EventList = (props) => {
    // const handleTransform = (eventData) => {
    //     return { ...eventData, customParameter: true };
    // };

    return (
        <CompleteCalendar
            {...props}
            CalendarProps={{
                plugins: [
                    dayGridPlugin,
                    timeGridPlugin,
                    interactionPlugin
                ],
                
                locale: faLocale,
                convertToEvent: (event) => ({
                    id: String(event.objectId),
                    title: event.title,
                    start: event.start,
                    end: event.end,
                    backgroundColor: event.backgroundColor||"orange",
                    textColor: event.backgroundColor||"orange",
                    color: event.backgroundColor||"orange",
                    borderColor: event.borderColor || "orange" ,
                    editable: event.editable,
                }),
            }}
        >
            <SimpleForm>
                <TextInput source="title" autoFocus />
                <IdateTimeInput source='start' label="شروع" />
                <IdateTimeInput source='end' label="پایان" />
            </SimpleForm>
        </CompleteCalendar>
    )
};
export const EventEdit = (props) => (
    <EditView {...props} perPage={1000}>
        <TextInput source="title" />
        <IdateTimeInput source='start' label="شروع" />
        <IdateTimeInput source='end' label="پایان" />
    </EditView>

);

export const EventCreate = (props) => (
    <CreateView {...props}>
        <TextInput source="title" />
        <IdateTimeInput source='start' label="شروع" />
        <IdateTimeInput source='end' label="پایان" />
    </CreateView>

);